import React from "react";

import ReactTable from "react-table";
import "react-table/react-table.css";
import { workingHoursAndMinutes } from "../../../../helpers";
import { Button } from "semantic-ui-react";
import { push } from "react-router-redux";

import moment from "moment";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";


class AdminClockReport extends React.Component {

  render() {
    let data = this.props.clocks;
    data = data.filter(
        (clock)=>(
            (clock.activity_id === this.props.activity_id || this.props.activity_id === null) &&
            (clock.warehouse_id === this.props.warehouse_id || this.props.warehouse_id === null) &&
            (clock.user_id === this.props.employee_id || this.props.employee_id === null) &&
            clock.duration > 1
        ));


      return (
      <div>
        <ReactTable
          data={data}
          columns={[
              {
                id: "name",
                Header: this.props.translate('clock.admin.report.columns.name'),
                accessor: d => d.user_name
              },
              {
                id: "warehouse",
                Header: this.props.translate('clock.admin.report.columns.warehouse'),
                accessor: d => d.warehouse_name
              },
              {
                id: "activity",
                Header: this.props.translate('clock.admin.report.columns.activity'),
                accessor: d => d.activity_name
              },
              {
                id: "date",
                Header: this.props.translate('clock.admin.report.columns.date'),
                accessor: d => moment(d.start,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')
              },
              {
                id: "time",
                Header: this.props.translate('clock.admin.report.columns.time'),
                accessor: d => moment(d.start,'YYYY-MM-DD HH:mm:ss').format('HH:mm')
              },
              {
                  id: "duration",
                  Header: this.props.translate('clock.admin.report.columns.duration'),
                  accessor: d => workingHoursAndMinutes(d.duration),
                  Cell: row => {
                    if(row.row.activity === 'ferien' || row.row.activity === 'krank'){
                      const days =  moment(row.original.end).diff(moment(row.original.start),'days')+1;
                      return <div>{days} Tage</div>;
                    }else{
                      return row.value;
                    }
                
                  },
                  Footer: ()=>{
                      let sumWorkingHours = data.map(d => {
                        if(d.activity_name === 'ferien' || d.activity_name === 'krank'){
                          return 0;
                        }
                        return d.duration
                      }).reduce((a,b)=>(a+b),0);
                      return workingHoursAndMinutes(sumWorkingHours);
                  }
              },
              {
                  id: "action",
                  Header: this.props.translate('clock.admin.report.columns.action'),
                  accessor: d => d.id,
                  Cell: row => (
                      <Button primary onClick={()=>{this.props.edit(row.value)}}>{this.props.translate('general.edit')}</Button>
                          )
              },
          ]}
          defaultPageSize={20}
          className="-striped -highlight"
          previousText={this.props.translate('general.previous')}
          nextText={this.props.translate('general.next')}
          loadingText={this.props.translate('general.loading')}
          noDataText={this.props.translate('general.noData')}
          pageText={this.props.translate('general.page')}
          ofText={this.props.translate('general.of')}
          rowsText={this.props.translate('general.rows')}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.localize)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return({
        edit: (id)=>{dispatch(push('/clock/admin/'+id))}
    })
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AdminClockReport)







// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/AdminReports/components/AdminClockReport/index.js